// Date helpers. The UI displays dates as d/m/yyyy (the API's ISO timestamps are
// converted in api/adapters.js); <input type="date"> speaks ISO; filenames want
// a sortable stamp.
//
// Everything here works off the LOCAL calendar date. `toISOString()` is UTC, so
// east of Greenwich it rolls over early in the evening and would stamp exports
// (and cap the date-of-birth field) a day behind.

const pad = (n) => String(n).padStart(2, '0');

// 27/7/2026
export const todayDmy = () => {
  const d = new Date();
  return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
};

// 2026-07-27 — for date-input `max` and filenames.
export const isoToday = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// '2026-07-27' → '27/7/2026'
export const isoToDmy = (iso) => {
  const [y, m, d] = iso.split('-');
  return `${Number(d)}/${Number(m)}/${y}`;
};

// '27/7/2026' → '2026-07-27', for seeding a date input from a displayed date.
// Anything that isn't d/m/yyyy gives '' (an empty input) rather than a bad date.
export const dmyToIso = (dmy) => {
  const m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(String(dmy || '').trim());
  return m ? `${m[3]}-${pad(m[2])}-${pad(m[1])}` : '';
};

// '2026-07-27' → '7/27/2026'. The create endpoints for assignments and quizzes
// parse their date with `new Date(string)`, which reads a slashed date as
// MONTH/day/year — so d/m/yyyy silently lands on the wrong day, or on an
// Invalid Date for any day past the 12th.
export const isoToMdy = (iso) => {
  const [y, m, d] = String(iso || '').split('-');
  return `${Number(m)}/${Number(d)}/${y}`;
};

// 27 Jul 2026 — the human stamp printed on exported PDFs.
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const longStamp = () => {
  const d = new Date();
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
};

// 'Aug 2026' — the month a page is reporting on, which is always the current one.
export const monthStamp = () => {
  const d = new Date();
  return `${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
};

// 'Saturday, August 8' — the greeting line on the dashboard. No year: it is
// today, so saying so would be noise.
export const todayLong = () => new Date().toLocaleDateString(undefined, {
  weekday: 'long',
  month: 'long',
  day: 'numeric',
});
